import { useMutation } from '@tanstack/react-query';
import { serverRequest2 } from '../util/server_request';
import { extractErrorMessage } from './extractErrorMessage';
import { notifyUser } from '../util/util';

const notifiedErrors = new Set();

const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

export function useRefundClaimRequest() {
  return useMutation({
    mutationFn: async (claimData) => {
      try {
        const formData = new FormData();
        formData.append('policy_number', claimData.policyNumber);
        formData.append('Current_cash_value', claimData.currentCashValue);
        formData.append('claim_amount', claimData.claimAmount);
        formData.append('payment_method', claimData.paymentMethod);
        formData.append('claim_default_telcomethod', claimData.telecomMethod);
        formData.append('claim_default_momo_wallet', claimData.momoWallet);
        formData.append('bank_name', claimData.bankName || '');
        formData.append('bank_account_number', claimData.accountNumber || '');
        formData.append('branch_name', claimData.branchName || '');
        formData.append('bank_account_name', claimData.accountName || '');

        const result = await serverRequest2('POST', 'policy/refund-claim-request', formData);
        if (!result || !result.success) {
          let message = result?.message || 'Failed to submit refund claim request';
          if (typeof message === 'object') {
            const errors = [];
            Object.keys(message).forEach(key => {
              const fieldLabel = key.replace(/_/g, ' ');
              if (Array.isArray(message[key])) {
                errors.push(`${fieldLabel}: ${message[key].join(', ')}`);
              } else {
                errors.push(`${fieldLabel}: ${message[key]}`);
              }
            });
            message = errors.join('. ') || 'Validation failed';
          }
          throw new Error(message);
        }
        return result;
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to submit refund claim request');
        notifyOnce("error", errorMessage, "Claim Error");
        throw new Error(errorMessage);
      }
    },
  });
}
